module.exports = __webpack_public_path__ + "img/7.aaf17bb7.jpg";